module.exports = __webpack_public_path__ + "app/principal/group/sub-entity/principal-group-add-sub-entity-iTairOvj.html";